import React, { useState, useEffect } from "react";
import { Tabs, ConfigProvider } from "antd";
import RegisterDevice from "./tab-component/RegisterDevice";
import VendorDownloadCertificate from "./tab-component/VendorDownloadCertificate";
import { useSelector } from "react-redux";
import ListMyDevices from "./tab-component/ListMyDevices";
import RegisterDevice1 from "./tab-component/RegisterDevice1";

const ManageVendors = () => {
  const [activeKey, setActiveKey] = useState(
    localStorage.getItem("activeTab") || "1"
  );
  const [tabPosition, setTabPosition] = useState("top");

  const items = [
    {
      key: "1",
      label: `Add Device`,
      component: RegisterDevice1,
    },
    {
      key: "2",
      label: `Download Certificate`,
      component: VendorDownloadCertificate,
    },
    {
      key: "3",
      label: `My Device Applications`,
      component: ListMyDevices,
    },
  ];

  const onTabClick = (key) => {
    localStorage.setItem("activeTab", key);
    setActiveKey(key);
  };

  

  const activeItem = items.find((item) => item.key === activeKey);
  const ActiveComponent = activeItem.component;

  return (
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            colorPrimary: "#1A472B",
            colorPrimaryHover: "#464947",
            colorPrimaryActive: "#464947",
            fontSize: 15,
          },
        },
      }}
    >
      <Tabs
        activeKey={activeKey}
        onTabClick={onTabClick}
        defaultActiveKey="1"
        tabPosition={tabPosition}
        style={{maxWidth: "100%"}}
      >
        {items.map((item) => (
          <Tabs.TabPane tab={item.label} key={item.key} forceRender={true}>
            {activeItem.key === item.key ? (
              <ActiveComponent activeKey={activeKey} />
            ) : null}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </ConfigProvider>
  );
};

export default ManageVendors;
